import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[vfsNumber]'
})
export class NumberDirective {
  @Input() allowSign: boolean = true;

  constructor(private element: ElementRef) {}

  /* Keyboard Listener */
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (!this.allowSign && this.getKeyName(event) === '-') {
      event.preventDefault();
    }
  }

  /* Paste from clipboard Listener */
  @HostListener('paste', ['$event']) onPaste(event) {
    let value = event.clipboardData.getData('text/plain');

    if (parseFloat(value) && parseFloat(value) > 0) {
      this.element.nativeElement.value = value;
    } else {
      this.element.nativeElement.value = 0;
      event.preventDefault();
    }
  }

  /**
   * getKeyName()
   * Gets the name of the pressed key
   */
  protected getKeyName(event): string {
    /* For newer browesers */
    if (event.key) {
      return event.key;
    } else {

    /* For older browsers */
      if (event.keyCode && String.fromCharCode) {
        switch (event.keyCode) {
          case 8:
            return 'Backspace';
          case 9:
            return 'Tab';
          case 27:
            return 'Escape';
          case 37:
            return 'ArrowLeft';
          case 39:
            return 'ArrowRight';
          case 188:
            return ',';
          case 190:
            return '.';
          case 109:
            return '-'; // Minus in numbpad
          case 173:
            return '-'; // Minus in alphabet keyboard in firefox
          case 189:
            return '-'; // Minus in alphabet keyboard in chrome
          default:
            return String.fromCharCode(event.keyCode);
        }
      }
    }
  }
}
